/**
 * Escala de monitores itinerantes (backend /escala/*).
 *
 * Admin: monta ciclos (período, vagas por turno, feriados), decide quem vai.
 * Itinerante: vê o calendário publicado, pede vaga e desiste.
 */
import api from './api';

export async function listarCiclos() {
  const response = await api.get('/escala/ciclos');
  return response.data;
}

export async function obterCiclo(id) {
  const response = await api.get(`/escala/ciclos/${id}`);
  return response.data;
}

export async function criarCiclo(dados) {
  const response = await api.post('/escala/ciclos', dados);
  return response.data;
}

export async function atualizarCiclo(id, dados) {
  const response = await api.patch(`/escala/ciclos/${id}`, dados);
  return response.data;
}

export async function excluirCiclo(id) {
  const response = await api.delete(`/escala/ciclos/${id}`);
  return response.data;
}

export async function listarCandidatos(cicloId) {
  const response = await api.get(`/escala/ciclos/${cicloId}/candidatos`);
  return response.data;
}

export async function atualizarDia(cicloId, diaId, dados) {
  const response = await api.patch(`/escala/ciclos/${cicloId}/dias/${diaId}`, dados);
  return response.data;
}

export async function atualizarDiasEmLote(cicloId, dados) {
  const response = await api.patch(`/escala/ciclos/${cicloId}/dias/lote`, dados);
  return response.data;
}

/** O próprio itinerante pede a vaga. */
export async function inscrever(cicloId, diaId, turno) {
  const response = await api.post(`/escala/ciclos/${cicloId}/inscricoes`, { diaId, turno });
  return response.data;
}

/** O próprio itinerante desiste. */
export async function desistir(inscricaoId) {
  const response = await api.delete(`/escala/inscricoes/${inscricaoId}`);
  return response.data;
}

/** Admin coloca alguém direto na escala. */
export async function escalar(cicloId, diaId, turno, userId) {
  const response = await api.post(`/escala/ciclos/${cicloId}/escalar`, { diaId, turno, userId });
  return response.data;
}

/** Admin decide: confirmado | recusado | pendente | cancelado. */
export async function decidirInscricao(inscricaoId, status, observacao) {
  const body = { status };
  if (observacao !== undefined) body.observacao = observacao;
  const response = await api.patch(`/escala/inscricoes/${inscricaoId}`, body);
  return response.data;
}

export async function aprovarPendentes(cicloId) {
  const response = await api.post(`/escala/ciclos/${cicloId}/aprovar-pendentes`);
  return response.data;
}

/** Meus próximos turnos (painel do militar). */
export async function minhasEscalas() {
  const response = await api.get('/escala/me');
  return response.data;
}
